(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["discount-popup"] && !Shopify.designMode) return;
  try {
    
const popup=document.querySelector('[data-lumuno-popup]');if(popup){const key=popup.dataset.storageKey;const sevenDays=604800000;const card=popup.querySelector('.lumuno-popup__card');const copy=popup.querySelector('[data-popup-copy]');const code=popup.querySelector('[data-popup-code]');let lastClosed=0;try{lastClosed=Number(localStorage.getItem(key))||0}catch(error){}const closePopup=()=>{popup.hidden=true;document.body.style.overflow='';try{localStorage.setItem(key,String(Date.now()))}catch(error){}};popup.querySelectorAll('[data-popup-close]').forEach(button=>button.addEventListener('click',closePopup));copy.addEventListener('click',async()=>{try{await navigator.clipboard.writeText(code.value)}catch(error){code.select();document.execCommand('copy')}copy.textContent=copy.dataset.copiedLabel;setTimeout(()=>{copy.textContent=copy.dataset.copyLabel},1800)});document.addEventListener('keydown',event=>{if(!popup.hidden&&event.key==='Escape')closePopup()});if(Date.now()-lastClosed>=sevenDays){setTimeout(()=>{popup.hidden=false;document.body.style.overflow='hidden';card.focus()},6000)}}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
